import { createReducer, on } from "@ngrx/store";
import { GlobalState } from "../app.state";
import {
  setContainerTypeAction,
  SetContainerTypeProps,
  setPermissionsAction,
  SetPermissionsProps,
  setScreenWidthAction,
  SetScreenWidthProps,
  setUserDetailAction,
  SetUserDetailProps,
  SetUserProps,
  showLoadingMaskAction,
  ShowLoadingMaskProps
} from "../actions/global.actions";
import * as GarageActions from "../actions/garage.actions";

const initialState: GlobalState = {};

export const globalReducer = createReducer(
  initialState,

  on(setContainerTypeAction, (state, data: SetContainerTypeProps) => {
    return ({
      ...state,
      containerType: data.containerType
    });
  }),

  on(setScreenWidthAction, (state, data: SetScreenWidthProps) => {
    return ({
      ...state,
      screenWidth: data.screenWidth
    });
  }),

  on(showLoadingMaskAction, (state, data: ShowLoadingMaskProps) => {
    return ({
      ...state,
      showLoadingMask: data.showLoadingMask
    });
  }),

  on(setPermissionsAction, (state, data: SetPermissionsProps) => {
    return ({
      ...state,
      permissions: data.permissions
    });
  }),

  on(setUserDetailAction, (state, data: SetUserDetailProps) => {
    return ({
      ...state,
      userDetail: data.userDetail
    });
  }),

  // Garage actions for user search
  on(GarageActions.loadUsersSuccess, (state, { users }) => {
    // Convert users array to map keyed by userId
    const userSearchResults = users.reduce((map, user) => {
      map[user.userId] = user;
      return map;
    }, {} as { [userId: string]: any });

    return ({
      ...state,
      userSearchResults
    });
  }),

  on(GarageActions.searchUsersSuccess, (state, { users }) => {
    // Convert users array to map keyed by userId
    const userSearchResults = users.reduce((map, user) => {
      map[user.userId] = user;
      return map;
    }, {} as { [userId: string]: any });

    return ({
      ...state,
      userSearchResults
    });
  }),

  on(GarageActions.clearUsers, (state) => {
    return ({
      ...state,
      userSearchResults: undefined
    });
  })
);
